import script from "./CompanyContact.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyContact.vue?vue&type=script&setup=true&lang=js"

import "./CompanyContact.vue?vue&type=style&index=0&id=31250a30&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31250a30"]])

export default __exports__